import { Stack, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { useCallback, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { FormPart } from '@modules/shared/components/FormPart';
import { Modal } from '@shared/components/modals/Modal';
import { NumberInputField } from '@shared/fields/NumberInputField';
import { TextInputField } from '@shared/fields/TextInputField';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { CommonButtonWrapper } from '@styles/CommonStyles';
import { ModalWrapper } from '@styles/StyledDiv';
import { getError } from '@shared/utils/helpers';

import { refreshWorkflow, setLastCommentsRefresh, setRefreshWorkflow } from '@store/reducers/contactManagerSlice';
import { IPushAppData } from '../../interfaces';
import { requestPushApp } from '../../queries';
import { flagshipOverrideValidation } from '../../validation';
import { LENDER_CODES } from '../constants';
import { IFlagshipModalProps } from './interfaces';

const initialValues = {
  comment: '',
  originalLoanAmount: null
};

const formConfig = [
  {
    width: '100%',
    label: 'Please Enter Current Auto Loan Lender and Report Showing Trade Here',
    name: 'comment',
    component: TextInputField,
  },
  {
    width: '30%',
    label: 'Original Loan Value',
    name: 'originalLoanAmount',
    component: NumberInputField,
  }
];

export const FlagshipOverrideModal = ({ setOpenFlagshipOverride, setOpenAutoLoansModal, data, refreshDealsTable, setLoanErrors, flagshipOverrideModalPosition }: IFlagshipModalProps) => {
  const dispatch = useDispatch();
  const refreshWorkflowSection = useSelector(refreshWorkflow);
  
  const [loading, setLoading] = useState(false);

  const lenderCode = data?.lenderResponse.lenderCode?.toUpperCase();
  const isFlagShip = lenderCode === LENDER_CODES.FLAG;
  const modalTitle = lenderCode === LENDER_CODES.FLAG ? 'Flagship' : lenderCode == LENDER_CODES.QLO ? 'Quilo Carter' : 'GLS';
  const handleClose = () => {
    if (!loading) {
      setOpenFlagshipOverride(0);
      setOpenAutoLoansModal && setOpenAutoLoansModal(0);
    }
  };

  const handleSubmit = useCallback(async(values: IPushAppData) => {
    setLoading(true);
    const payload = {
      dealId: data?.id,
      comment: `${values.comment} - Original Value: ${values.originalLoanAmount}`,
      originalLoanAmount: values.originalLoanAmount,
      openDate: ''
    };

    const response = lenderCode && await requestPushApp(payload);
    
    if (!response?.isSuccess && response?.response?.status != 500) {
      const error = getError(response);
      setLoanErrors([error]);
      setOpenFlagshipOverride(0);
      setOpenAutoLoansModal && setOpenAutoLoansModal(0);
      return;
    }

    if (response?.isSuccess) {
      dispatch(setLastCommentsRefresh(new Date().toISOString()));
      dispatch(setRefreshWorkflow(refreshWorkflowSection));
      refreshDealsTable && (await refreshDealsTable());
    } else {
      setLoanErrors(response?.errors ?? []);
    }
    setLoading(false);
    setOpenFlagshipOverride(0);
    setOpenAutoLoansModal && setOpenAutoLoansModal(0);
  }, [data, lenderCode, isFlagShip, refreshWorkflowSection]);

  return (
    <>
      <Modal
        open
        title={`${modalTitle} Override`}
        dialogWidth="800px"
        resetPosition={flagshipOverrideModalPosition}
        onClose={handleClose}
      >
        <ModalWrapper>
          <Typography my={3}>
            A original loan value is not found on the Transunion credit report.
            Enter in the values below to continue submitting the application:
          </Typography>

          <Formik
            enableReinitialize
            initialValues={initialValues as IPushAppData}
            validationSchema={flagshipOverrideValidation}
            onSubmit={handleSubmit}
          >
            {(props) => (
              <Form onSubmit={props.handleSubmit}>
                <Stack gap={3} mb={2}>
                  <FormPart config={formConfig} />
                </Stack>
                <CommonButtonWrapper direction="row">
                  <CancelButton onClick={handleClose} />
                  <SaveButton isLoading={loading} label="Override" />
                </CommonButtonWrapper>
              </Form>
            )}
          </Formik>
        </ModalWrapper>
      </Modal>
    </>
  );
};